import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import { persistStore } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import { thunk } from 'redux-thunk';
// import logger from 'redux-logger';

// Import your reducers here
// import someReducer from './someReducer';
import restaurantReducer from './reducers/restaurant';

// const persistConfig = {
//   key: 'root',
//   storage,
// };

const rootReducer = combineReducers({
  // Add your reducers here
  // someReducer,
  restaurant: restaurantReducer,
});

// const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk),
  devTools: process.env.NODE_ENV !== 'production',
});

// const persistor = persistStore(store);

export { store };
